var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.loader)?[_c('button',{staticClass:"retry-btn",attrs:{"type":"button"},on:{"click":_vm.retry}},[_c('i',{staticClass:"fa fa-repeat"})])]:[_c('Loader',{attrs:{"size":'small',"align":'start'}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }